import permissions from "../generated/permissions.json";
import type { User } from "../types/models";

export function hasPermission(user: User | null | undefined, permission: string): boolean {
  if (!user) {
    return false;
  }
  return user.role === "admin" || (user.permissions ?? []).includes(permission);
}

export function canAccessAdmin(user: User | null | undefined): boolean {
  if (!user) {
    return false;
  }
  const knownAdminPermissions = permissions.filter(
    (permission) => permission.startsWith("admin.") || permission === "audit.read" || permission.startsWith("users.")
  );
  return user.role === "admin" || knownAdminPermissions.some((permission) => (user.permissions ?? []).includes(permission));
}
